"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SECONDARY_EMAIL = exports.SIGN_UP = void 0;
exports.SIGN_UP = 'signup';
exports.SECONDARY_EMAIL = 'secondaryEmail';
